import moment from "moment";
import { RecordingObject } from "@remo-co/types";

export const getRecordingName = (
  eventCode: string,
  recording: RecordingObject,
): string =>
  `${eventCode}-${moment(recording.start_ts * 1000).format("HH:mm")}`;
